import React from 'react';
import styles from './Shimmer.module.scss';

const Shimmer = () => {
  const shimmerItems = [1, 2, 3, 4, 5];
  return (
    <>
      <div className="p-20">
        <div className={`${styles.Shimmer_shimmer_faqsearch} ${styles.shimmerwrap} mt-20`} />
        <ul className="mt-10">
          {shimmerItems.map((item) => (
            <li key={item} className={`${styles.Shimmer_shimmer_faq} ${styles.shimmerwrap}`} />
          ))}
        </ul>
      </div>
    </>
  );
};

export default Shimmer;
